import { MainButtonProps } from "@/types/components/MainButtonProps";

const MainButton = ({ type = 'button', children, className = '', ...props }: MainButtonProps) => {
    return(
        <button {...props} type={type} className={`rounded py-3 px-6 font-semibold  text-center w-full ${props.disabled ? 'bg-slateGray text-midnightAbyss cursor-not-allowed' : 'text-arcticMist bg-gradientButton' } text-16 leading-6 transition-theme hover:enabled:shadow-buttonHover focus:bg-accordorange focus-visible:bg-accordorange ${className}`}>
            {children}
        </button>
    )
}

export default MainButton;